import PropTypes from "prop-types";
import { forwardRef } from "react";
// @mui
import Box from "@mui/material/Box";
//
import { IMAGE_BASE } from "src/config-global";

// ----------------------------------------------------------------------

const SvgColor = forwardRef(({ src, sx, disabledBase, ...other }, ref) => {
    const _src = disabledBase ? src : IMAGE_BASE + src;

    return (
        <Box
            component="span"
            className="svg-color"
            ref={ref}
            src={_src}
            sx={{
                width: 24,
                height: 24,
                display: "inline-block",
                backgroundColor: "currentColor",
                mask: `url(${_src}) no-repeat center / contain`,
                WebkitMask: `url(${_src}) no-repeat center / contain`,
                ...sx
            }}
            {...other}
        />
    )
});

SvgColor.propTypes = {
    src: PropTypes.string,
    disabledBase: PropTypes.bool,
    sx: PropTypes.object
};

export default SvgColor;
